import { createApp } from 'vue'
import App from './App.vue'
import router from './routers'
import store from './store';
import './tailwind.css'
import VueApexCharts from 'vue3-apexcharts';
import axios from 'axios';

// Configure axios to use proxy when VUE_APP_SERVICE_URL is empty
// This avoids CORS issues by routing requests through the dev server proxy
const serviceUrl = process.env.VUE_APP_SERVICE_URL || '';
if (!serviceUrl || serviceUrl === '') {
  // Use relative URLs to leverage vue.config.js proxy
  axios.defaults.baseURL = '';
  // Make serviceUrl available globally for backward compatibility
  window.VUE_APP_SERVICE_URL = '';
} else {
  axios.defaults.baseURL = serviceUrl;
  window.VUE_APP_SERVICE_URL = serviceUrl;
}

// Setup axios interceptor to redirect to login on 401 errors
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      router.push({ name: 'login' });
    }
    return Promise.reject(error);
  }
);

createApp(App).use(router).use(store).use(VueApexCharts).mount('#app');